import { Box, Divider, Typography } from '@mui/material';
import type { ContractStatus, Plan } from '@weft/types';
import { ContractStatusChip } from 'apps/app/src/components/design/ContractStatusChip';
import React from 'react';
import { ContractNavbarTag } from './ContractNavbarTag';

type ContractNavbarProps = {
  contractId: string;
  plan: Plan;
  description?: string;
  status: ContractStatus;
  contractEndDate?: Date;
};

export const ContractNavbar: React.FC<ContractNavbarProps> = ({ contractId, plan, description, status, contractEndDate }) => {
  return (
    <>
      <ContractStatusChip
        status={status}
        endDate={contractEndDate}
        style={{ padding: '7px 10px' }}
      />
      <Divider
        orientation="vertical"
        flexItem
        className='text-placeholder m-2'
      />

      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
          fontSize: '16px',
          lineHeight: '150%',
          letterSpacing: '-0.16px',
        }}
      >
        Ref. #
        {contractId.substring(contractId.length - 5)}
      </Typography>

      <Divider
        orientation="vertical"
        flexItem
        className='text-placeholder m-2'
      />
     
      {plan.billingData.autoRenewal && ( 
        <Box sx={{ display: 'flex', gap: '8px' }}>
          <ContractNavbarTag
            label="Auto Renew"
          />
        </Box>
      )}

      <Box sx={{ display: 'flex', gap: '8px' }}>
        <ContractNavbarTag
          label={plan.billingData.paymentTerm}
        />
      </Box>

      {description && (
        <>
          <Divider
            orientation="vertical"
            flexItem
            className='text-placeholder m-2'
          />
          <Typography sx={{ fontSize: '16px' }}>
            {description}
          </Typography>
        </>
      )}
      <Divider
        orientation="vertical"
        flexItem
        className='text-placeholder m-2'
      />
    </>
  );
};